/**
 * The two searches behind the sidebar's two rows.
 *
 * They are separate dialogs, not one palette with a tab strip: "find a topic"
 * and "hear this word" are different questions with different answers, and a
 * tab hid the second one behind a control nobody opened. Each row names its
 * own search and opens its own surface.
 *
 * The pronunciation one used to be called "In context". That described where
 * the words were found rather than what a learner does with them. Its route is
 * still `/videos/in-context` on purpose: the old URL is in bookmarks, in shared
 * links and in the topic-page buttons, and a rename is not worth breaking them.
 */
export type SearchMode = "topics" | "pronunciation";

/** Where the topics search hands its query off to page through every result. */
export function topicsSearchPath(query: string): string {
  return `/topics?q=${encodeURIComponent(query)}`;
}

/** The full watch desk for a pronunciation search. */
export function pronunciationSearchPath(query: string): string {
  return `/videos/in-context?q=${encodeURIComponent(query)}`;
}
